import React, {useState} from 'react';
import {ReportForm, schoolYears, showWarningNotify, TreeCheckboxInput} from "../../components";
import {downloadFilePost} from "../../components/FileDownload";
import env from "../../env";
import Card from "@material-ui/core/Card";
import {AutocompleteInput, DateInput, ReferenceArrayInput, ReferenceInput, required, Title} from "react-admin";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

const NapEventReport = ({...props}) => {
    const [state, setState] = useState({
        fromDate: new Date(),
        toDate: new Date(),
        eventIds: [],
        unitIds: [],
        isLoading: false
    });


    const excelReport = () => {
        if (!state.unitIds || state.unitIds.length === 0) {
            showWarningNotify('Vui lòng chọn danh sách lớp/phòng ban')
            return;
        }
        setState({...state, isLoading: true})
        const data = {
            from: moment(state.fromDate).format('YYYY-MM-DD'),
            to: moment(state.toDate).format('YYYY-MM-DD'),
            unitIds: state.unitIds,
            eventId: state.eventId
        }
        downloadFilePost(`${env.reportURL}/reports/nap-event`, 'bao_cao_ngu_trua.xlsx', data)
            .finally(() => {
                setState({...state, isLoading: false})
            })
    };

    const validate = (values) => {
        const errors = {};
        setState(values);
        return errors;
    };

    return (
        <Card>
            <Title title="resources.nap-event-report.name"/>
            <CardContent>
                <ReportForm validate={validate}
                            excelReport={excelReport}
                            params={state}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.fromDate" source="fromDate"
                                       validate={required()}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.toDate" source="toDate" validate={required()}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label>Danh sách lớp *</label>
                            <ReferenceArrayInput source="unitIds" reference="baseUnits"
                                                 filter={{
                                                     schoolYearId: schoolYears.length > 0 ? schoolYears[0].id : '',
                                                     clazzOnly: true
                                                 }}
                                                 perPage={999} {...props}
                                                 label='Lớp'
                            >
                                <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                            </ReferenceArrayInput>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ReferenceInput source="eventId"
                                            reference="events"
                                            label="resources.nap-event-report.event"
                                            validate={required()}
                                            perPage={50}
                                            filter={{filterPath: 'filterSimple', type: 'NAP'}}
                                            sort={{field: 'name', order: 'ASC'}}>
                                <AutocompleteInput source="name"/>
                            </ReferenceInput>
                        </Grid>

                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default NapEventReport;
